// extracted by mini-css-extract-plugin
module.exports = {"paginationButton":"Pagination_paginationButton__X7lMu"};